<template lang="pug">

tr(v-bind:class='{ disabled: hideActions && !isAccepted }')

    td
        i.star.icon(v-if="isBestPrice" v-tooltip="'Ist Bestpreis'")
        span(v-else) &nbsp;

    //- Auflage
    td {{ priceModel.printing }}

    //- Stückpreis
    td {{ unitPrice | money }}

    //- Versandkosten
    td {{ shipping | money }}

    //- Gesamtpreis
    td {{ total | money }}

    //- Actions
    td.right.aligned
        //- Angebot akzeptieren
        button.ui.small.compact.basic.icon.button(
            v-tooltip="'Angebot wählen'"
            v-on:click="showModal()"
            v-if="!hideActions && !isAccepted"
        )
            i.checkmark.icon

        // Preis wurde akzeptiert
        i.green.checkmark.icon(v-if='isAccepted' v-tooltip='"Dieser Preis wurde akzeptiert"')

        modal(ref="modal")
            span(slot="header") Ausgewähltes Angebot
            span(slot="content")
                table.ui.definition.table
                    tbody
                        tr
                            td Auflage
                            td {{ priceModel.printing }} Stück
                        tr
                            td Produktionskosten
                            td {{ production | money }}
                        tr
                            td Versandkosten
                            td {{ shipping | money }}
                        tr(v-if="priceModel.additionalCosts && priceModel.additionalCosts.length")
                            td Zusatzkosten
                            td {{ additionalCosts | money }}
                        tr.total
                            td Gesamtpreis
                            td
                                strong {{ total | money }}
                        tr
                            td Stückpreis
                            td {{ unitPrice | money }}
            action-row(
                slot="footer"
                saveLabel="Angebot verbindlich bestätigen"
                v-on:cancel="closeModal()"
                v-on:save="acceptPrice()"
            )

</template>

<script>
    import * as PriceUtils from '@/utils/price'
    import ActionRow from '@/components/form/ActionRow.vue'
    import Modal from '@/components/app/Modal.vue'
    import * as R from "ramda";

    //noinspection JSUnusedGlobalSymbols,ReservedWordAsName
    export default {

        components: { ActionRow, Modal },

        computed: {

            isAccepted() {
                return this.productModel.price === this.priceModel.id
            },

            production() {
                return PriceUtils.production_selling_sum(this.priceModel)
            },

            shipping() {
                return PriceUtils.shipping_selling_sum(this.priceModel)
            },

            total() {
                return PriceUtils.total_selling_sum(this.priceModel)
            },

            unitPrice() {
                return PriceUtils.per_unit_sum(this.priceModel)
            },

            additionalCosts() {
                return PriceUtils.additional_costs_price(this.priceModel)
            }

        },

        methods: {

            async acceptPrice() {
                try {
                    // Preis in Produkt setzen
                    const priceId = this.priceModel.id
                    const productModel = R.merge(this.productModel, { price: priceId, status: 'OFFER_CONFIRMED' })

                    // Produkt speichern
                    await this.$store.dispatch('products/update', { id: productModel.id, model: productModel })

                    // Produkt neu laden
                    await this.$store.dispatch('products/loadOne', {
                        id: this.productModel.id,
                        force: true
                    })

                    // Erfolgsmeldung anzeigen
                    this.$growl.success('Preis wurde akzeptiert')

                    // Modal closen
                    this.closeModal()

                } catch (e) {
                    // ggf. Fehlermeldung anzeigen
                    this.$growl.fatal('Preis konnte nicht akzeptiert werden', e)
                }
            },

            closeModal() {
                this.$refs.modal.close()
            },

            showModal() {
                this.$refs.modal.show()
            }

        },

        props: {

            hideActions: {
                type: Boolean,
                required: false
            },

            isBestPrice: {
                type: Boolean,
                default: false
            },

            priceModel: {
                type: Object,
                required: true
            },

            productModel: {
                type: Object,
                required: true
            },

        }

    }

</script>
